export const NAVIGATION_ITEMS = {
  MASTERS: {
    id: "masters",
    label: "Masters",
    icon: "globe",
    items: [
      {
        id: "doctor-schedule",
        label: "Doctor Schedule Master",
        icon: "timeline-events",
        path: "/v3/masters/doctor-schedules",
        entityType: "doctorScheduleMaster",
      },
      {
        id: "insurance-panel",
        label: "Payment Panel Master",
        icon: "inner-join",
        path: "/v3/masters/insurance-panel",
        entityType: "insurancePanelMaster",
      },
      {
        id: "insurance-company",
        label: "Insurance Company Master",
        icon: "bank-account",
        path: "/v3/masters/insurance-company",
        entityType: "insuranceCompanyMaster",
      },
      {
        id: "tpa-master",
        label: "TPA Master",
        icon: "inner-join",
        path: "/v3/masters/tpa-master",
        entityType: "tpaMaster",
      },
      {
        id: "surgery-group",
        label: "Surgery Group Master",
        icon: "cut",
        path: "/v3/masters/surgery-group",
        entityType: "surgeryGroupMaster",
      },
      {
        id: "surgery-payment-master",
        label: "Surgery Payment Master",
        icon: "bank-account",
        path: "/v3/masters/surgery-payment-master",
        entityType: "surgeryPaymentMaster",
      },
      {
        id: "anesthesia-payment-master",
        label: "Anesthesia Payment Master",
        icon: "syringe",
        path: "/v3/masters/anesthesia-payment-master",
        entityType: "anesthesiaPaymentMaster",
      },
      {
        id: "discharge-templates",
        label: "Discharge Templates",
        icon: "code-block",
        path: "/v3/masters/discharge-templates",
        entityType: "sxDischargeTemplateMaster",
      },
    ],
  },
  WORKFLOW: {
    id: "workflow",
    label: "Workflow",
    icon: "calendar",
    items: [
      {
        id: "sx-calendar-branchwise",
        label: "Branchwise Calendar",
        icon: "timeline-events",
        path: "/v3/workflow/sx-calendar-branchwise",
        entityType: "sxCalendarBranchwise",
      },
      {
        id: "doctorwise-calendar",
        label: "Doctorwise Calendar",
        icon: "calendar",
        path: "/v3/workflow/doctorwise-calendar",
        entityType: "doctorwiseCalendar",
      },
      {
        id: "surgery-search",
        label: "Surgery Search",
        icon: "search",
        path: "/v3/workflow/surgery-search",
        entityType: "surgerySearch",
      },
      // {
      //   id: 'patient-search',
      //   label: 'Patient Search',
      //   icon: 'search',
      //   path: '/patientSearch',
      //   entityType: 'patientSearch'
      // },
      {
        id: "surgery-booking",
        label: "Surgery Booking",
        icon: "cut",
        path: "/v3/workflow/surgery-booking",
        entityType: "surgeryBooking",
      },
      {
        id: "cash-till",
        label: "Cash Till",
        icon: "bank-account",
        path: "/v3/workflow/cash-till",
        entityType: "cashTill",
      },
      //    {
      //     id: "surgery-workflow",
      //     label: "Surgery Workflow",
      //     icon: "automatic-updates",
      //     path: "/v3/workflow/surgery-workflow",
      //     entityType: "surgeryWorkflow",
      //    },
      // {
      //   id: 'booking-metadata',
      //   label: 'Booking Metadata',
      //   icon: 'form',
      //   path: '/bookingMetadata',
      //   entityType: 'bookingMetadata'
      // }
    ],
  },
  REPORTS: {
    id: "reports",
    label: "Reports",
    icon: "document",
    items: [
      {
        id: "discharge-register",
        label: "Discharge Register",
        icon: "send-to-graph",
        path: "/v3/reports/discharge-register",
        entityType: "dischargeRegister",
      },
      {
        id: "booking-register",
        label: "Booking Register",
        icon: "list-detail-view",
        path: "/v3/reports/booking-register",
        entityType: "bookingRegister",
      },
      {
        id: "pending-surgery-register",
        label: "Pending Surgery Register",
        icon: "clipboard",
        path: "/v3/reports/pending-surgery-register",
        entityType: "pendingSurgeryRegister",
      },
      {
        id: "postponed-register",
        label: "Postponed Register",
        icon: "history",
        path: "/v3/reports/postponed-register",
        entityType: "postponedRegister",
      },
      {
        id: "cancelled-surgeries",
        label: "Cancelled Surgeries",
        icon: "disable",
        path: "/v3/reports/cancelled-surgeries",
        entityType: "cancelledSurgeries",
      },
      {
        id: "anaesthetist-report",
        label: "Anaesthetist Report",
        icon: "th-list",
        path: "/v3/reports/anaesthetist-report",
        entityType: "anaesthetistReport",
      },
      {
        id: "booking-given",
        label: "Booking Given",
        icon: "timeline-events",
        path: "/v3/reports/booking-given",
        entityType: "bookingGiven",
      },
      // {
      //   id: "ipd-register",
      //   label: "IPD Register",
      //   icon: "home",
      //   path: "/v3/reports/ipd-register",
      //   entityType: "ipdRegister",
      // },
      {
        id: "ipd-bill-register",
        label: "IPD Bill Register",
        icon: "credit-card",
        path: "/v3/reports/ipd-bill-register",
        entityType: "ipdBillRegister",
      },
      {
        id: "ipd-age-gender",
        label: "IPD Age/Gender",
        icon: "panel-table",
        path: "/v3/reports/ipd-age-gender",
        entityType: "ipdAgeGender",
      },
      {
        id: "tpa-payment-panel",
        label: "TPA Payment Panel",
        icon: "credit-card",
        path: "/v3/reports/tpa-payment-panel",
        entityType: "tpaPaymentPanel",
      },
      {
        id: "mr-bill-register",
        label: "MR Bill Register",
        icon: "credit-card",
        path: "/v3/reports/mr-bill-register",
        entityType: "mrBillRegister",
      },
      {
        id: "master-report",
        label: "Master Report",
        icon: "list-detail-view",
        path: "/v3/reports/master-report",
        entityType: "masterReport",
      },
      {
        id: "implant-invoice-report",
        label: "Implant Invoice Report",
        icon: "eye-open",
        path: "/v3/reports/implant-invoice-report",
        entityType: "implantInvoiceReport",
      },
    ],
  },
  ADMINISTRATION: {
    id: "administration",
    label: "Administration",
    icon: "shield",
    items: [
      {
        id: "audit-logs",
        label: "Audit Logs",
        icon: "history",
        path: "/v3/administration/audit-logs",
        entityType: "auditLogs",
      },
    ],
  },
};

export const NAVIGATION_ORDER = [
  "MASTERS",
  "WORKFLOW",
  "REPORTS",
  "ADMINISTRATION",
];
